import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CustomerLeafCollectionReport } from './Pages';

export const CustomerLeafCollectionReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={CustomerLeafCollectionReport} />
       
    </Fragment>
)